import { z } from 'zod';

import { DepositMethod } from 'data/payments/models';

export const DepositRateType = z.enum(['SBER', 'RAPIRA']);
export type DepositRateType = z.infer<typeof DepositRateType>;

export const DepositRate = z.object({
  rate: z.string(),
  rateType: DepositRateType,
  methods: z
    .object({
      method: DepositMethod,
      inCurrency: z.string(),
      feePercentage: z.string(),
      effectiveRate: z.string(),
    })
    .array(),
});

export type DepositRate = z.infer<typeof DepositRate>;
